// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_uj-0";
export var checkoutRateBadgeLink = "_uj-1";